import * as THREE from "three";

const PARALLEL_EPSILON = 1e-10;
// Crossings are only reported strictly inside both segments, so segments sharing an endpoint
// (every pair of adjacent edges) never count as a self-intersection.
const INTERIOR_EPSILON = 1e-6;

/**
 * Intersection of two segments in XZ, but only when they cross in the interior of both.
 * Returns null for parallel segments and for touches at the endpoints.
 */
function intersectSegments({
	firstStart,
	firstEnd,
	secondStart,
	secondEnd,
}: {
	firstStart: THREE.Vector3;
	firstEnd: THREE.Vector3;
	secondStart: THREE.Vector3;
	secondEnd: THREE.Vector3;
}): THREE.Vector3 | null {
	const firstX = firstEnd.x - firstStart.x;
	const firstZ = firstEnd.z - firstStart.z;
	const secondX = secondEnd.x - secondStart.x;
	const secondZ = secondEnd.z - secondStart.z;

	const determinant = firstX * secondZ - firstZ * secondX;

	if (Math.abs(determinant) < PARALLEL_EPSILON) {
		return null;
	}

	const deltaX = secondStart.x - firstStart.x;
	const deltaZ = secondStart.z - firstStart.z;

	const alongFirst = (deltaX * secondZ - deltaZ * secondX) / determinant;
	const alongSecond = (deltaX * firstZ - deltaZ * firstX) / determinant;

	const isInsideBoth =
		alongFirst > INTERIOR_EPSILON && alongFirst < 1 - INTERIOR_EPSILON && alongSecond > INTERIOR_EPSILON && alongSecond < 1 - INTERIOR_EPSILON;

	if (isInsideBoth === false) {
		return null;
	}

	return new THREE.Vector3(firstStart.x + alongFirst * firstX, firstStart.y + alongFirst * (firstEnd.y - firstStart.y), firstStart.z + alongFirst * firstZ);
}

export { intersectSegments };
